var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[`btn mat pull-left mr-20`, _vm.buttonTypeClass],on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._t("icon"),_vm._v(" "),_vm._t("default",function(){return [_vm._v("Back")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }